import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Button = styled('button')`
  align-items: center;
  background-color: #ffffffdd;
  border: none;
  border-radius: 10pt;
  box-shadow: #0000001a 0pt 3pt 6pt;
  color: #6f6f6f !important;
  display: flex;
  font-family: 'museo-sans', sans-serif;
  font-weight: 600;
  font-size: 1.33rem !important;
  height: 55pt;
  justify-content: center;
  margin: auto;
  margin-bottom: 19pt;
  opacity: 80%;
  text-decoration: none;
  width: 80vw;

  &:hover {
    box-shadow: #00000033 0pt 3pt 6pt;
    opacity: 100%;
  }

  @media screen and (min-width: 768px) {
    width: 240pt;
  }
`
const LinkButton = styled(Link)`
  align-items: center;
  background-color: #ffffffdd;
  border: none;
  border-radius: 10pt;
  box-shadow: #0000001a 0pt 3pt 6pt;
  color: #6f6f6f !important;
  display: flex;
  font-family: 'museo-sans', sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  height: 55pt;
  justify-content: center;
  margin: auto;
  margin-bottom: 19pt;
  opacity: 80%;
  text-decoration: none;
  width: 80vw;

  &:hover {
    box-shadow: #00000033 0pt 3pt 6pt;
    opacity: 100%;
  }

  @media screen and (min-width: 768px) {
    width: 240pt;
  }
`

const SelectButton = ({ last, value, onclick, minutes, link, linkto }) => {
  if (link) {
    return (
      <LinkButton to={linkto}>
        {value} {minutes ? 'minutes' : null}
      </LinkButton>
    )
  }
  return (
    <Button onClick={onclick}>
      {value} {minutes ? 'minutes' : null}
    </Button>
  )
}

export default SelectButton
